import React, { useState, useEffect } from 'react';
import { Typography, Table, TableHead, TableCell, TableRow, TableBody, TableContainer, TablePagination, Grid, LinearProgress } from '@mui/material';
import { useParams } from 'react-router-dom';
function tableBod(data, type) {

 
  let returnTableBody = [];
  for (let index = 0; index < data.length; index++) {

    returnTableBody.push(
      <TableRow key={index}>
        <TableCell align='center'>
          <Typography>{data[index].ProgramName}</Typography>
        </TableCell>
        <TableCell align='center'>
          <Typography>{data[index].EventName}</Typography>
        </TableCell>
        <TableCell align='center'>
          <Typography>{data[index].UserName}</Typography>
        </TableCell>
        <TableCell align='center'>
          <Typography>{data[index].EventDate}</Typography>
        </TableCell>
        <TableCell align='center'>
          <Typography> {data[index].Credit}</Typography>
        </TableCell>
        <TableCell align='center'>
          <Typography> {data[index].Debit}</Typography>
        </TableCell>
      </TableRow>
    );

  }
  return returnTableBody;
}
function CredsDataTable() {

  const [data, setCredorDebitData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalValue, setTotalValue] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const type=2;
  const [programName, setprogramName] = useState('');
  const firstName = localStorage.getItem('first_name');
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    setCredorDebitData(getCreditorDebitDetails(type));
    // eslint-disable-next-line
  }, []);

  async function getCreditorDebitDetails(type) {
    try {
      //console.log(id,"id")
      var endPoint = `/api/program/events/cred/view?program_id=${id}`;
      if (parseInt(type) === 2) {
        endPoint = `/api/cred/events/eventid/list/view?event_id=${id}`;
      }

      fetch(process.env.REACT_APP_API_URL + endPoint, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(),
      })
        .then((res) => res.json())
        .then((data) => {
          let count = 0;

          setCredorDebitData(data.response.response_data);
          if (parseInt(type) === 1) {
            setprogramName(data.response.response_data[0].ProgramName);
          } else {
            setprogramName(data.response.response_data[0].EventName);
          }

          data.response.response_data.forEach((i) => {
            count = count + i.Credit + i.Debit;
          });
          setTotalValue(count);
          setIsLoading(false);
        })
        .catch((err) => {
          //console.log(err);
        });
    } catch (er) {
      //console.log(er);
    }
  }

  if (!isLoading) {
    if (data.length > 0) {
      return (
        <Grid style={{ padding: '2vh' }}>
          <Grid container spacing={2} mt={2}>
            <Grid item xs={11}>
              <Typography variant='h5' ml={5} mb={1}>
                Hi {firstName}, {parseInt(type) === 1 ? 'credits' : 'debits'} splits
                for {parseInt(type) === 1 ? 'program ' : 'event'} {programName}{' '}
              </Typography>
              <Typography ml={5}>
                Time cred$ exchanged : {totalValue}
              </Typography>
            </Grid>
          </Grid>
          <TableContainer sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label='sticky table'>
              <TableHead>
                <TableRow>
                  <TableCell align='center'>
                    <Typography>Program name</Typography>
                  </TableCell>
                  <TableCell align='center'>
                    <Typography>Event name</Typography>
                  </TableCell>
                  <TableCell align='center'>
                    <Typography>User name</Typography>
                  </TableCell>
                  <TableCell align='center'>
                    <Typography>Event date</Typography>
                  </TableCell>
                  <TableCell align='center'>
                    <Typography align='center'>
                      Credits
                    </Typography>

                  </TableCell>
                  <TableCell>
                    <Typography align='center'>
                      Debits
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{tableBod(data.slice((page) * rowsPerPage, rowsPerPage * (page + 1)), type)}</TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component='div'
            count={tableBod(data, type).length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Grid>
      )
    } else {
      return (
        <div>
          <Typography variant='h5' p={5} ml={5} style={{ marginLeft: 40 }}>
            No Cred$ found for the {parseInt(type) === 1 ? 'program ' : 'event'}
          </Typography>
        </div>
      )
    }


  } else {
    return (
      <div style={{ marginTop: 20, textAlign: 'center' }}>
        <img alt={'logo'} style={{ height: 350, width: 300 }} src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`} />
        <LinearProgress />
      </div>
    );
  }
}
export default CredsDataTable;
